import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import Home from "../src/components/Home"
import Artefactos from "../src/pages/Artefactos"
import Login from "../src/components/Login"
import Register from "../src/components/Register"
import SetDisplayName from "../src/components/DisplayName/SetDisplayName"
import ProtectedRoute from "../src/components/ProtectedRoute"
import SetupRoute from "../src/components/SetupRoute"
import SemillasEnCamara from "../src/components/SemillasEnCamara"
import PartidasRiesgo from "../src/pages/PartidasRiesgoNew"
import KPIArticulos from "../src/pages/KPIArticulos"
import GeneradorXLSX from "../src/pages/GeneradorXLSX"
import NuevoArtefacto from "../src/pages/NuevoArtefacto"
import PrivacyChats from "../src/pages/PrivacyChats"
import VectorGenerator from "../src/pages/VectorGenerator"
import RolesManager from "../src/pages/RolesManager"
import KPISemillero from "../src/pages/KPISemillero"
import Inversiones from "../src/pages/Inversiones"
import DetalleTarea from "../src/pages/DetalleTarea"
import { AuthProvider } from "../src/context/AuthContext"

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route 
            path="/configuser" 
            element={
              <ProtectedRoute>
                <SetDisplayName />
              </ProtectedRoute>
            } 
          />
          <Route
            path="/home"
            element={
              <SetupRoute>
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              </SetupRoute>
            }
          />
          <Route
            path="/chat"
            element={
              <SetupRoute>
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              </SetupRoute>
            }
          />
          <Route
            path="/artefactos"
            element={
              <SetupRoute>
                <ProtectedRoute>
                  <Artefactos />
                </ProtectedRoute>
              </SetupRoute>
            }
          />
          <Route
            path="/artefactos/partidasriesgo"
            element={
              <SetupRoute>
                <ProtectedRoute>
                  <PartidasRiesgo />
                </ProtectedRoute>
              </SetupRoute>
            }
          />
          <Route
            path="/artefactos/kpiarticulos"
            element={
              <SetupRoute>
                <ProtectedRoute>
                  <KPIArticulos />
                </ProtectedRoute>
              </SetupRoute>
            }
          />
          <Route
            path="/artefactos/generadorxlsx"
            element={
              <SetupRoute>
                <ProtectedRoute>
                  <GeneradorXLSX />
                </ProtectedRoute>
              </SetupRoute>
            }
          />
          <Route
            path="/artefactos/nuevo-artefacto"
            element={
              <SetupRoute>
                <ProtectedRoute>
                  <NuevoArtefacto />
                </ProtectedRoute>
              </SetupRoute>
            }
          />
          <Route
            path="/semillasencamara"
            element={
              <SetupRoute>
                <ProtectedRoute>
                  <SemillasEnCamara />
                </ProtectedRoute>
              </SetupRoute>
            }
          />
          {/* KPI Semillero - Documentación de análisis SQL */}
          <Route
            path="/artefactos/kpisemillero"
            element={
              <SetupRoute>
                <ProtectedRoute>
                  <KPISemillero />
                </ProtectedRoute>
              </SetupRoute>
            }
          />
          {/* Inversiones - Módulo de gestión de inversiones */}
          <Route
            path="/inversiones"
            element={
              <SetupRoute>
                <ProtectedRoute>
                  <Inversiones />
                </ProtectedRoute>
              </SetupRoute>
            }
          />
          {/* Detalle de Tarea - Recuperación de clientes */}
          <Route
            path="/inversiones/recuperacion-clientes"
            element={
              <SetupRoute>
                <ProtectedRoute>
                  <DetalleTarea />
                </ProtectedRoute>
              </SetupRoute>
            }
          />
          {/* Ruta oculta de administración - no aparece en sidebar */}
          <Route
            path="/privacychats"
            element={
              <ProtectedRoute>
                <PrivacyChats />
              </ProtectedRoute>
            }
          />
          {/* Generador vectorial huerto - ruta oculta */}
          <Route
            path="/vectorgenerator"
            element={
              <ProtectedRoute>
                <VectorGenerator />
              </ProtectedRoute>
            }
          />
          {/* Gestión de Roles y Áreas - Panel de administración */}
          <Route
            path="/roles"
            element={
              <ProtectedRoute>
                <RolesManager />
              </ProtectedRoute>
            }
          />
          {/* Ruta legacy para compatibilidad */}
          <Route path="/partidasriesgo" element={<Navigate to="/artefactos/partidasriesgo" replace />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  )
}